/**
 * Count the unicode code points of a given string. Returns 0 if null or undefined is given.
 * @see https://medium.com/@tanishiking/count-the-number-of-unicode-code-points-in-javascript-on-cross-browser-62c32b8d919c
 * @see https://dev.to/ihavecoke/how-to-caculate-emoji-length-36df
 *
 * The backend (Text Message Service) also counts the unicode code points for validation.
 *
 * @param {string|null} value
 * @return {number}
 */
export function countUnicodeCodePoints(value) {
    // match(/./gu) => doesn't count line breaks
    // The spread operator takes care of splitting the string by "Unicode codepoints" whereas a simple ".length" would just count UTF chars.
    return (value && [...value].length) || 0
}
